import { useLocation } from 'react-router-dom';
import { useGuestAccessHashBase } from './useGuestAccessHashBase';

export const useGuestAccessHash = (selector) => {
    const { search } = useLocation();
    return useGuestAccessHashBase(selector, search);
};
